import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { PUZZLE_ICON } from "common/constants"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"

export const ModalNoHayInvitacionesAsesorias = ({
  isOpen = false,
  onConfirm,
}: {
  isOpen: boolean
  onConfirm?: () => void
}) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-80 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Actions'
          className='tw-flex'
        >
          <ButtonPrimeReact
            label={`${t("crear.asesoria.modal.continueButton")}`}
            className='tw-w-full tw-h-12 !tw-bg-primary !tw-border-none tw-text-simple-10 tw-items-center'
            onClick={onConfirm}
          />
        </div>
      }
    >
      <>
        <div className='tw-w-32 tw-h-32 tw-flex tw-justify-center tw-items-center tw-mx-auto tw-mt-5 tw-mb-6'>
          <img
            src={PUZZLE_ICON}
            alt='Imagen_puzzle'
          />
        </div>
        <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
          {t("crear.asesoria.modal.noRequests")}
        </div>
        <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-text-center tw-px-4'>
          <p className='tw-mb-3'>
            {t("crear.asesoria.modal.noRequestsMessage")}
          </p>
        </div>
      </>
    </PrimeReactModal>
  )
}
